import Logo from "../icons/logo.jsx";
import "../styles/footer.style.scss";
import "../styles/content.style.scss";
import { Link } from "react-router-dom";
function Footer() {
  return (
    <footer>
      <div className="ctn-content">
        <div className="footer-container">
          <div className="logo-ctn">
            <Link to="/">
              <Logo fill={"#fff"} />
            </Link>
            <span>2023 © généralite Informatique</span>
            <span className="info">Tous les droit reservé</span>
          </div>
          <nav className="ctn-link">
            <ul className="nav-link">
              <li>
                <Link to="/">Accueil</Link>
              </li>
              <li>
                <Link to="/ventes">Ventes</Link>
              </li>
              <li>
                <Link to="/about">A propos</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </nav>
          <nav className="ctn-link link-social">
            <ul className="nav-link">
              <li>
                <a
                  href="https://www.facebook.com/generaliteinformatique?mibextid=ZbWKwL"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="mailto:generaliteinformatque@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Email
                </a>
              </li>
              <li>
                <a
                  href="https://www.whatsapp.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Whatsapp
                </a>
              </li>
              <li>
                <a
                  href="tel:691891212"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Nous Appelez
                </a>
              </li>
            </ul>
          </nav>
          <nav className="ctn-link info">
            <ul className="nav-link">
              <li>
                <a href=".">Politique Privee</a>
              </li>
              <li>
                <a href=".">Terme de service</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="b-foot">
        <h3 className="t-center slogan">
          Travaillons ensemble pour votre securite
        </h3>
      </div>
    </footer>
  );
}
export default Footer;
